/**
 * Weighted Moving Average (WMA)
 *
 * Linear-weighted moving average giving proportionally greater weight to
 * recent bars.  Weight of bar i = i + 1 (oldest bar gets weight 1).
 *
 * Category: Trend | Pane: Overlay
 */
import { IndicatorDefinition, PlotData } from "../types/indicator.types";
import { CandleData } from "../../types/chart.types";
import { getSource } from "./sma";

export const wmaIndicator: IndicatorDefinition = {
  id: "wma",
  name: "Weighted Moving Average",
  shortName: "WMA",
  category: "trend",
  pane: "overlay",
  params: [
    { key: "period", label: "Period", type: "number", default: 20, min: 1, max: 500 },
    { key: "source", label: "Source", type: "select", default: "close", options: [
      { label: "Close", value: "close" }, { label: "Open", value: "open" },
      { label: "High", value: "high" }, { label: "Low", value: "low" },
    ]},
    { key: "color", label: "Color", type: "color", default: "#E040FB" },
  ],
  plots: [
    { key: "wma", label: "WMA", color: "#E040FB", style: "line", lineWidth: 2 },
  ],
  calculate: (candles: CandleData[], params: Record<string, any>): PlotData[] => {
    const { period, source = "close" } = params;
    const src = getSource(candles, source);
    const data: { time: number; value: number }[] = [];
    const weightSum = (period * (period + 1)) / 2;

    for (let i = period - 1; i < src.length; i++) {
      let wSum = 0;
      for (let j = 0; j < period; j++) {
        wSum += src[i - period + 1 + j] * (j + 1);
      }
      data.push({ time: candles[i].time, value: wSum / weightSum });
    }
    return [{ key: "wma", data }];
  },
};
